// extracted by mini-css-extract-plugin
export default {"section":"Companies_section__D1C43","title":"Companies_title__cvIq6","carousel":"Companies_carousel__XeZDH"};